import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {apiGet, apiPost} from '../../../../features/auth/api/apiClient';
import {endPoints} from '../../../../features/auth/constants/endPoints';
import {appConstants} from '../../../constants/global';
import {globalErrorHandler} from '../../../error/GlobalErrorController';
import mockData from '../../../components/layout/Header/mocks/Header.json';
import {IndirectActivityResponse} from '../../../components/layout/Header/HeaderProps';

export const useHeaderController = () => {
  const dispatch = useDispatch();

  const getIndirectActivities = useCallback(async (): Promise<
    IndirectActivityResponse[] | undefined
  > => {
    try {
      if (appConstants.isMock) {
        return mockData.data;
      }
      const {data: response} = await apiGet<IndirectActivityResponse[]>({
        endpoint: `${endPoints.header.indirectActivity}`,
      });

      if (response?.success) {
        if (response?.data) {
          return response.data;
        }
      }
    } catch (error: any) {
      globalErrorHandler({error, dispatch});
      throw error;
    }
  }, [dispatch]);

  const confirmIndirectActivity = useCallback(
    async (
      activityId: number,
      technicianId: number,
      userTimeZone: string,
      isIndirectOvertimeCheckRequired = true,
      isPromptOvertimeCheckRequired = true,
    ) => {
      try {
        if (appConstants.isMock) {
          return {
            success: true,
            message: 'Mock confirmation for activity ID: ' + activityId,
          };
        }
        const payload: Record<string, string | number | boolean> = {
          repairGroupComponentActionID: activityId,
          userTimeZone,
          isIndirectOvertimeCheckRequired,
          isPromptOvertimeCheckRequired,
        };
        const {data: response} = await apiPost<string>({
          endpoint: endPoints.header.saveIndirectActivity(technicianId),
          payload,
        });

        if (response) {
          return {
            isSuccess: response?.success ?? false,
            message: response?.message ?? '',
          };
        }
      } catch (error: any) {
        // Re-throw so the caller (Header.tsx) can show the appropriate
        // Yes/No overtime confirmation modal instead of a generic toast.
        throw error;
      }
    },
    [],
  );

  return {
    getIndirectActivities,
    confirmIndirectActivity,
  };
};
